import { useTranslation } from 'react-i18next';

import { ALL_ATE_AGENCY_IDS } from '@ngsos/portal-core/agency';

import { DataPanel, DataPanelInlineItem, AgencyView } from '@/ui';
import type { AdditionalIncidentData } from '@/signalr';
import { CallSignPanelItem } from './CallSignPanelItem';

export type AdditionalDataSectionProps = {
  incidentId: string;
  incidentIsReadOnly: boolean;
  additionalIncidentData: AdditionalIncidentData;
};

export function AdditionalDataSection({
  incidentId,
  incidentIsReadOnly,
  additionalIncidentData,
}: AdditionalDataSectionProps) {
  const { t } = useTranslation();

  return (
    <DataPanel header={t('Incident_InfoPanel_AdditionalIncidentData_PanelHeader')}>
      <CallSignPanelItem
        incidentId={incidentId}
        callSign={additionalIncidentData.callSign}
        incidentIsReadOnly={incidentIsReadOnly}
      />

      {additionalIncidentData.ateMessage != null && additionalIncidentData.ateMessage.trim() !== '' && (
        <AgencyView agencyIds={ALL_ATE_AGENCY_IDS}>
          <DataPanelInlineItem
            title={t('Incident_InfoPanel_AteMessage')}
            value={additionalIncidentData.ateMessage}
            editable={false}
            showEmptyPlaceholder
          />
        </AgencyView>
      )}
    </DataPanel>
  );
}
